import { useContext } from 'react';
import { ContextInterface } from './types';
import TranslationContext from './TranslationContext';

function useTranslation(): ContextInterface {
  const context = useContext(TranslationContext);
  if (!context) {
    throw new Error(
      'useTranslation must be used within an TranslationProvider',
    );
  }

  return context;
}

export default useTranslation;
